import { useUrlState } from "../useUrlState.js";
import { useCallback } from "react";
import { useUpdateEffect } from "ahooks";
//#region src/hooks/usePaginationState/index.ts
function usePaginationState(key, optsOrDeps = {}, deps = []) {
	let _opts = {};
	let _deps = [];
	if (Array.isArray(optsOrDeps)) _deps = optsOrDeps;
	else if (typeof optsOrDeps === "object") {
		_opts = optsOrDeps;
		if (Array.isArray(deps)) _deps = deps;
	}
	const [recordsPerPage, setRecordsPerPage] = useUrlState(`${key}_limit`, _opts.defaultRecordsPerPage || 25);
	const [skippedRecords, setSkippedRecords] = useUrlState(`${key}_skip`, _opts.defaultSkippedRecords || 0);
	const resetPage = useCallback(() => setSkippedRecords(0), []);
	useUpdateEffect(() => {
		resetPage();
	}, _deps);
	useUpdateEffect(() => {
		setSkippedRecords(0);
	}, [recordsPerPage]);
	return {
		recordsPerPage: Number(recordsPerPage || 0),
		resetPage,
		setRecordsPerPage,
		setSkippedRecords,
		skippedRecords: Number(skippedRecords || 0)
	};
}
//#endregion
export { usePaginationState };

//# sourceMappingURL=index.js.map